import axios from "axios";
import { professionalUrl } from "../../utils";

export const fetchProfessional = async (professionalId: string) => {
  return await axios.get(professionalUrl(professionalId));
};
